export default "__VITE_ASSET__5332784a__"